import { MulticastDelegate, MulticastDelegate1 } from "flavr-common";
export class Consumer {
    constructor({ id, localId, producerId, transceiver, stream, track }) {
        this._closed = false;
        this.onCloseDelegate = new MulticastDelegate();
        this.onTransportcloseDelegate = new MulticastDelegate();
        this.onPauseDelegate = new MulticastDelegate();
        this.onResumeDelegate = new MulticastDelegate();
        this.onTrackEndedDelegate = new MulticastDelegate();
        this.onNegotiationNeededDelegate = new MulticastDelegate();
        this.onStreamChangedDelegate = new MulticastDelegate1();
        this.onTrackEnded = () => {
            this.onTrackEndedDelegate.invoke();
        };
        this.onTrackMuted = () => { };
        this.onTrackUnmuted = () => { };
        this._id = id;
        this._localId = localId;
        this._producerId = producerId;
        this._transceiver = transceiver;
        this._stream = stream;
        this._track = track;
        this._paused = !track.enabled;
        this.handleTrack();
    }
    get id() {
        return this._id;
    }
    get localId() {
        return this._localId;
    }
    get mid() {
        return this.transceiver.mid;
    }
    get producerId() {
        return this._producerId;
    }
    get closed() {
        return this._closed;
    }
    get paused() {
        return this._paused;
    }
    get kind() {
        return this._track.kind;
    }
    get stream() {
        return this._stream;
    }
    get transceiver() {
        return this._transceiver;
    }
    get track() {
        return this._track;
    }
    get muted() {
        if (this._closed)
            return true;
        if (!this._stream.active)
            return true;
        if (this._transceiver.stopped)
            return true;
        if (this._transceiver.currentDirection === "recvonly")
            return false;
        return this._transceiver.currentDirection !== "sendrecv";
    }
    get direction() {
        if (this._transceiver.currentDirection === null) {
            return "null";
        }
        return this._transceiver.currentDirection;
    }
    close() {
        if (this._closed)
            return;
        this._closed = true;
        this.destroyTrack();
        this.onCloseDelegate.invoke();
        this.clear();
    }
    transportClosed() {
        if (this._closed)
            return;
        this._closed = true;
        this.destroyTrack();
        this.onTransportcloseDelegate.invoke();
        this.onCloseDelegate.invoke();
        this.clear();
    }
    clear() {
        this.onCloseDelegate.clear();
        this.onTransportcloseDelegate.clear();
        this.onPauseDelegate.clear();
        this.onResumeDelegate.clear();
        this.onTrackEndedDelegate.clear();
        this.onNegotiationNeededDelegate.clear();
    }
    pause() {
        if (this._closed) {
            console.error("[multiplayer] pause() | Consumer closed");
            return;
        }
        this._paused = true;
        this._track.enabled = false;
        this.onPauseDelegate.invoke();
    }
    resume() {
        if (this._closed) {
            console.error("[multiplayer] resume() | Consumer closed");
            return;
        }
        this._paused = false;
        this._track.enabled = true;
        this.onResumeDelegate.invoke();
    }
    enable(enabled) {
        if (!this._transceiver)
            return;
        if (this._transceiver.stopped)
            return;
        if (this._transceiver.direction === "stopped")
            return;
        const newDirection = enabled ? "recvonly" : "inactive";
        if (this._transceiver.direction === newDirection)
            return;
        this._transceiver.direction = newDirection;
        this.onNegotiationNeededDelegate.invoke();
    }
    changeStream(stream) {
        if (this._stream === stream)
            return;
        const oldStream = this._stream;
        this._stream = stream;
        this.onStreamChangedDelegate.invoke(oldStream);
    }
    handleTrack() {
        this._track.addEventListener("ended", this.onTrackEnded);
        this._track.addEventListener("mute", this.onTrackMuted);
        this._track.addEventListener("unmute", this.onTrackUnmuted);
        this.stream.addEventListener("inactive", this.onTrackEnded);
    }
    destroyTrack() {
        try {
            console.log("[multiplayer] Consumer destroyTrack", this._track.id, this.mid, this._producerId);
            this._track.removeEventListener("ended", this.onTrackEnded);
            this._track.removeEventListener("mute", this.onTrackEnded);
            this._track.removeEventListener("unmute", this.onTrackEnded);
            this.stream.removeEventListener("inactive", this.onTrackEnded);
            this._track.stop();
        }
        catch (error) { }
    }
}
